var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"disabled-text-input",attrs:{"disabled":"","dense":"","outlined":"","value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }